import { AppConstants } from '../../shared/constants/constants';

export class Page {
    //The number of elements in the page
    size: number = AppConstants.pagingConfig.pageSize;
    //The total number of elements
    totalElements: number = 0;
    //The total number of pages
    totalPages: number = 0;
    //The current page number
    pageNumber: number = 0;

    public constructor(size: number = null) {
        if (size) {
            this.size = size;
        }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/list/page.model.ts